import axios from "axios";
import { store } from "../app/store";
import { logout } from "../features/authSlice";

let setGlobalLoading;
let activeRequests = 0;
let loaderTimeout = null;

export const setLoader = (setLoading) => {
  setGlobalLoading = setLoading;
};

// const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
// const isLocalHost =
//   typeof window !== "undefined" &&
//   ["localhost", "127.0.0.1"].includes(window.location.hostname);
// const localBaseUrl = "https://mdk7v2f6-5000.inc1.devtunnels.ms";
// const remoteBaseUrl = "https://mdk7v2f6-5000.inc1.devtunnels.ms";

const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

export const REAL_BASE_URL = configuredBaseUrl;

const BASE_URL = REAL_BASE_URL;

export const RD_URL = process.env.REACT_RD_API_BASE_URL?.trim();



// export const REAL_BASE_URL = isLocalHost
//   ? localBaseUrl
//   : configuredBaseUrl || remoteBaseUrl;
// const BASE_URL = REAL_BASE_URL;

const clearAuthStorage = () => {
  store.dispatch(logout());
};

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  withCredentials: true,
});

let refreshPromise = null;

const readCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

axiosInstance.interceptors.request.use(
  (config) => {
    activeRequests += 1;
    if (!loaderTimeout) {
      loaderTimeout = setTimeout(() => {
        if (setGlobalLoading) setGlobalLoading(true);
      }, 150);
    }
    const state = store.getState();
    config.headers["X-App-Client"] = "admin";
    const csrfToken = readCookie("ezypay_csrf");
    if (csrfToken && !["get", "head", "options"].includes(config.method?.toLowerCase())) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }
    if (config.data instanceof FormData) {
      if (config.headers && typeof config.headers.delete === "function") {
        config.headers.delete("Content-Type");
      } else {
        delete config.headers["Content-Type"];
      }
    } else if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    activeRequests = Math.max(0, activeRequests - 1);
    return Promise.reject(error);
  }
);

const finishLoader = () => {
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests === 0) {
    clearTimeout(loaderTimeout);
    loaderTimeout = null;
    if (setGlobalLoading) setGlobalLoading(false);
  }
};

axiosInstance.interceptors.response.use(
  (response) => {
    finishLoader();
    return response;
  },
  async (error) => {
    finishLoader();
    const request = error.config;
    const url = request?.url || "";
    const isRefreshRequest = url.includes("/api/auth/refresh");
    const isSessionCheck = url.includes("/api/auth/session");
    const isAuthRequest =
      url.includes("/api/auth/login") ||
      url.includes("/api/auth/verify/mpin");

    if (
      error?.response?.status === 401 &&
      request &&
      !request._authRetry &&
      !request._skipAuthRetry &&
      !isRefreshRequest &&
      !isSessionCheck &&
      !isAuthRequest
    ) {
      if (!refreshPromise) {
        refreshPromise = axiosInstance
          .post("/api/auth/refresh", null, { _authRetry: true })
          .finally(() => {
            refreshPromise = null;
          });
      }
      try {
        await refreshPromise;
        return axiosInstance({ ...request, _authRetry: true });
      } catch {
        const loggedIn = Boolean(store.getState()?.auth?.userInfo);
        clearAuthStorage();
        if (
          loggedIn &&
          typeof window !== "undefined" &&
          !window.location.pathname.startsWith("/verify") &&
          window.location.pathname !== "/"
        ) {
          window.location.href = "/";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
